import {
  BooleanField,
  FuzzyField,
  NumberField,
  SelectField,
  TextField,
  useStudioForm,
} from "~/components/Form";
import { FiltersSidebar, withoutBaseTableModel } from "~/components/Table";
import { CommonFilters } from "~/domain/common";
import {
  LogSelect,
  ObjectStoreSelect,
  processStateOptions,
  WorkflowSelect,
} from "~/lqs";
import { listIngestionsSchema } from "../schemas";
import { useIngestionSearchRequest } from "./IngestionTable";

export function IngestionFilters() {
  const [request, setRequest] = useIngestionSearchRequest();

  const { control, handleSubmit } = useStudioForm({
    schema: listIngestionsSchema,
    values: withoutBaseTableModel(request),
    onSubmit: setRequest,
  });

  return (
    <FiltersSidebar handleSubmit={handleSubmit}>
      <TextField control={control} name="id" />
      <FuzzyField control={control} exactName="name" fuzzyName="nameLike" />
      <LogSelect control={control} name="logId" />
      <WorkflowSelect control={control} name="workflowId" />
      <BooleanField control={control} name="workflowIdNull" />
      <ObjectStoreSelect control={control} name="objectStoreId" />
      <FuzzyField
        control={control}
        exactName="objectKey"
        fuzzyName="objectKeyLike"
      />
      <SelectField
        control={control}
        name="state"
        options={processStateOptions}
      />
      <TextField control={control} name="noteLike" label="Note" />
      <NumberField control={control} name="progressGte" />
      <NumberField control={control} name="progressLte" />
      <BooleanField control={control} name="progressNull" />
      <CommonFilters control={control} />
    </FiltersSidebar>
  );
}
